module.exports = __webpack_public_path__ + "img/active1.bbe4579e.png";